/**
 * API 根地址（无末尾斜杠）。
 *
 * - 当前页 host 为 localhost / 127.0.0.1 / ::1：使用同源相对路径 `/api`，由 Vite dev/preview 代理到
 *   `vite.config` 中配置的后端（见 `VITE_API_BASE_URL`），避免浏览器 CORS。
 * - 其它环境（线上）：使用当前浏览器 `location.origin` + `/api`。
 */
export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') {
    return (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080').replace(/\/$/, '');
  }
  const host = window.location.hostname;
  const isLocal =
    host === 'localhost' || host === '127.0.0.1' || host === '::1';
  if (isLocal) {
    return '/api';
  }
  const origin = window.location.origin.replace(/\/$/, '');
  return `${origin}/api`;
}
